export default __webpack_public_path__ + "static/media/Mark-3-HUD-09.c60e3a66.jpg";